// Mitgliedsabo ruht ein Jahr, wenn ein Mitglied Fachkraft für Musik oder den Kita-Gitarrenkurs bucht (Fragen 354 und
// 355, Daniel 16.10.2026: „Das muss aber wirklich klar kommuniziert werden“). Gerechnet und pausiert wird nur auf dem
// Server (`create-bundle-checkout`, `_shared/mitglied-abo-ruhen.ts`); die Seiten zeigen das Datum, das der Server meldet:
// `detect_tariff` → `aboRuhen.bis` (vor dem Knopf), Antwort der Buchung → `abo_ruht_bis` (Dankeseite über `?ruht=`),
// `check-abo-subscription` → `pause_resumes_at` („Mein Account“). Dieselben Sätze in alter und neuer Ansicht.
//
// Testphase (Frage 360): Wer in der Testphase der Mitgliedschaft bucht, dessen Testphase endet zu ihrem Ende von selbst,
// ohne Rechnung (`detect_tariff` → `testphaseEndet.bis`, Buchung → `testphase_endet_bis`, Dankeseite über `?testende=`).
//
// Ohne Importe: liegt in der alten Kasse, der neuen Kasse, beiden Dankeseiten und beiden „Mein Account“.

/** „16. Oktober 2027“ in Berliner Zeit; leer bei unlesbarem Datum. */
export function ruhenDatum(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric", timeZone: "Europe/Berlin" });
}

export const RUHEN_TITEL_KASSE = "Dein Mitgliedsabo ruht ein Jahr";
export const RUHEN_TITEL_DANKE = "Dein Mitgliedsabo ruht";

/** Vor dem Kaufknopf, wenn `detect_tariff` ein Abo meldet, das beim Buchen ruht. */
export function ruhenSatzKasse(bisIso: string): string {
  return `Mit der Buchung ruht die Abbuchung deiner Mitgliedschaft bis zum ${ruhenDatum(bisIso)}. In dieser Zeit zahlst du nur die Ausbildung, deine Mitgliedschaft mit allen Kursen bleibt offen. Danach läuft dein Abo zu den bisherigen Bedingungen von selbst weiter. Kündigen kannst du es wie immer in „Mein Account“.`;
}

/** Ausbildungsseite für angemeldete Mitglieder, deren Abo beim Buchen ruhen würde. */
export function ruhenSatzSeite(bisIso: string): string {
  return `Buchst du jetzt, ruht dein Mitgliedsabo bis zum ${ruhenDatum(bisIso)}: Bis dahin wird dafür nichts abgebucht, danach läuft es von selbst weiter.`;
}

/** Dankeseite nach der Buchung (`?ruht=` aus der Antwort der Kasse). */
export function ruhenSatzDanke(bisIso: string): string {
  return `Dein Mitgliedsabo ruht bis zum ${ruhenDatum(bisIso)}: Bis dahin wird dafür nichts abgebucht, danach läuft es von selbst weiter. Du siehst das jederzeit in „Mein Account“ unter „Abo & Rechnungen“.`;
}

/** „Mein Account“, solange das Abo ruht (`is_currently_paused`, `pause_resumes_at`). Gilt auch für die Pause aus dem Halteangebot. */
export function ruhenSatzAccount(bisIso: string | null | undefined): string {
  const bis = ruhenDatum(bisIso);
  return bis
    ? `Dein Abo ruht bis zum ${bis}. Bis dahin wird nichts abgebucht, danach läuft es von selbst weiter. Fällige Monate erscheinen in dieser Zeit bei den Rechnungen als „Storniert“.`
    : "Dein Abo ruht gerade. Bis dahin wird nichts abgebucht, danach läuft es von selbst weiter.";
}

/** Kurz für Pillen und Zeilen: „Ruht bis 16. Oktober 2027“. */
export function ruhenKurz(bisIso: string | null | undefined): string {
  const bis = ruhenDatum(bisIso);
  return bis ? `Ruht bis ${bis}` : "Ruht";
}

export const TESTPHASE_TITEL = "Deine Testphase endet von selbst";

/** Vor dem Kaufknopf, wenn `detect_tariff` eine Testphase meldet, die beim Buchen ausläuft. */
export function testphaseSatzKasse(bisIso: string): string {
  return `Die Ausbildung enthält ein Jahr Mitgliedschaft. Mit der Buchung endet deine Testphase am ${ruhenDatum(bisIso)} von selbst, ohne Rechnung und ohne Abo danach. Deinen Zugang hält ab dann die Ausbildung offen.`;
}

/** Ausbildungsseite für Angemeldete in der Testphase. */
export function testphaseSatzSeite(bisIso: string): string {
  return `Buchst du jetzt, endet deine Testphase am ${ruhenDatum(bisIso)} von selbst, ohne Rechnung: Das Jahr Mitgliedschaft ist in der Ausbildung enthalten.`;
}

/** Dankeseite nach der Buchung (`?testende=`). */
export function testphaseSatzDanke(bisIso: string): string {
  return `Deine Testphase endet am ${ruhenDatum(bisIso)} von selbst, es kommt keine Rechnung dafür. Ab dann hält die Ausbildung deinen Zugang offen. In „Mein Account“ steht sie als gekündigt.`;
}
